import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { Page, PageHeader } from '../ui'
import { MilitaryHearingLossAdminStats } from '../components/views/militaryHearingLossView/MilitaryHearingLossAdminStats/MilitaryHearingLossAdminStats'

function MilitaryHearingLossAdmin() {
    return (
        <div className="home">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader eyebrow="Military Hearing Loss" title="Agent Stats" />
                    <MilitaryHearingLossAdminStats />
                </Page>
            </MainView>
        </div>
    )
}

export default MilitaryHearingLossAdmin
